// extracted by mini-css-extract-plugin
export default {"modalCont":"PhoneNumberModal_modalCont__UflQL","PhoneTitle":"PhoneNumberModal_PhoneTitle__AU6lc","PhoneNum":"PhoneNumberModal_PhoneNum__aSxHl"};